module.exports = __webpack_public_path__ + "img/icon_connect.70372c1c.png";